import GroupAvatar from "./GroupAvatar";
import LetterAvatar from "./LetterAvatar";
import ImageAvatar from "./ImageAvatar";

const Avatar = {
  GroupAvatar,
  LetterAvatar,
  ImageAvatar,
};

export default Avatar;
